/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 19:00:02
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getBuserList
   * @description 获取B端用户列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getBuserList(data) {
    return request.get(`${BASE_URL}/buser/list`, data)
  },

  /**
   * createBuser
   * @description 新增B端用户信息
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createBuser(data) {
    return request.post(`${BASE_URL}/buser/store`, data)
  },

  /**
   * updateBuser
   * @description 编辑B端用户信息
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateBuser(id, data) {
    return request.put(`${BASE_URL}/buser/update/${id}`, data)
  },

  /**
   * viewBuser
   * @description B端用户信息详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  viewBuser(data) {
    return request.get(`${BASE_URL}/buser/view/${data}`)
  },

  /**
   * deleteBuser
   * @description 删除B端用户信息
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  deleteBuser(id) {
    return request.Delete(`${BASE_URL}/buser/delete/${id}`)
  }
  
}